module.exports = __webpack_public_path__ + "img/af32ff6.png";